import type {
  EfteruddannelseIndberetningStatusId,
  PersonPaalaegStatusId,
} from "@/api/person/paalaeg";

import type { StatusBadgeVariant } from "./StatusBadge";

export const mapPaalaegStatusLabel = (
  status: PersonPaalaegStatusId,
): string => {
  switch (status) {
    case "Aabent":
      return "Åben";
    case "Lukket":
      return "Afsluttet";
    case "Slettet":
      return "Slettet";
    default:
      return status;
  }
};

export const mapPaalaegStatusBadgeVariant = (
  status: PersonPaalaegStatusId,
): StatusBadgeVariant => {
  switch (status) {
    case "Aabent":
      return "primary";
    case "Lukket":
      return "secondary";
    case "Slettet":
      return "muted";
    default:
      return "muted";
  }
};

export const mapIndberetningStatusLabel = (
  status: EfteruddannelseIndberetningStatusId | null | undefined,
): string => {
  if (!status) return "-";

  switch (status) {
    case "FristOrdinaer":
      return "Frist ordinær";
    case "ModtagetUdenFejl":
      return "Modtaget uden fejl";
    case "ModtagetMedFejl":
      return "Modtaget med fejl";
    case "Undersoeges":
      return "Undersøges";
    case "IndbragtForAdvokatnaevnet":
      return "Indbragt for advokatnævnet";
    case "Henlagt":
      return "Henlagt";
    case "Ukendt":
      return "Ukendt";
    default:
      return status;
  }
};

export const mapIndberetningStatusBadgeVariant = (
  status: EfteruddannelseIndberetningStatusId | null | undefined,
): StatusBadgeVariant => {
  switch (status) {
    case "FristOrdinaer":
      return "muted";
    case "ModtagetUdenFejl":
      return "success";
    case "ModtagetMedFejl":
      return "warning";
    case "Undersoeges":
      return "info";
    case "Henlagt":
      return "secondary";
    default:
      return "muted";
  }
};

export const filterVisiblePaalaeg = <
  T extends { status: PersonPaalaegStatusId },
>(
  paalaegList: T[],
): T[] =>
  Array.isArray(paalaegList)
    ? paalaegList.filter((p) => p.status !== "Slettet")
    : [];
